export const NEW_ON_EDEL_DATA = "NEW_ON_EDEL_DATA";
export const NEW_ON_EDEL_START_LOADER = "NEW_ON_EDEL_START_LOADER";
export const NEW_ON_EDEL_STOP_LOADER = "NEW_ON_EDEL_STOP_LOADER";
export const NEW_ON_EDEL_HIDE_ERROR = "NEW_ON_EDEL_HIDE_ERROR";
export const NEW_ON_EDEL_SET_ERROR = "NEW_ON_EDEL_SET_ERROR";
